module.exports = __webpack_public_path__ + "img/b2e1be70f70a40859834302449f643a8-640.24aeaf93.jpg";